enum OnboardingStatusEnum {
  NOT_STARTED = 'not_started',
  RUNNING = 'running',
  FAILED = 'failed',
  PENDING = 'pending',
  COMPLETED = 'completed',
}

export default OnboardingStatusEnum;
